import { Outlet, useOutletContext } from 'react-router-dom'
import NavBar from '@/src/components/nav-bar/NavBar'
import { PageHeadersCtx } from '@/src/hooks/use-page-headers/usePageHeaders'

const RootLayout = () => {
  const { setTitle, setSubTitle } = useOutletContext<PageHeadersCtx>()
  return (
    <div className="h-full pb-20">
      <Outlet context={{ setTitle, setSubTitle }} />
      <div className="sticky bottom-0 left-0 right-0">
        <NavBar />
      </div>
    </div>
  )
}

export default RootLayout
